<template>
  <div class="row mx-5">
    <p style="width: 100%;">Ваш баланс: {{ balance }} руб. (хватит на {{ showDays(balance) }} дней)</p>
    <div class="input-group mb-2">
      <input v-model="pay_summ" min="0" type="number" style="max-width: 200px;" class="form-control" placeholder="Сумма пополнения" aria-label="Сумма пополнения" aria-describedby="basic-addon2">
      <div class="input-group-append">
        <span class="input-group-text" id="basic-addon2">Примерно {{ showDays(pay_summ) }} дней</span>
      </div>
    </div>
    <div class="mb-3" style="width: 100%;">
      <button @click="pay_summ = 30*price" type="button" class="btn btn-light mr-1">1 месяц</button>
      <button @click="pay_summ = 90*price" type="button" class="btn btn-light mr-1">3 месяца</button>
      <button @click="pay_summ = 180*price" type="button" class="btn btn-light mr-1">6 месяцев</button>
      <button @click="pay_summ = 365*price" type="button" class="btn btn-light">1 год</button>
    </div>
    <div>
      <button @click="payCard" type="button" class="btn btn-primary mr-2">Пополнить картой</button>
      <button @click="payBill" type="button" class="btn btn-primary">Пополнить через расчетный счет</button>
    </div>
    <form id="pay_form" method="POST">
      <input type="hidden" name="Description" value="" />
      <input type="hidden" name="Encoding" value="" />
      <input type="hidden" name="ExpirationDate" value="" />
      <input type="hidden" name="InvId" value="" />
      <input type="hidden" name="MerchantLogin" value="" />
      <input type="hidden" name="OutSum" value="" />
      <input type="hidden" name="Receipt" value="" />
      <input type="hidden" name="SignatureValue" value="" />
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import urls from '@/lib/urls'
import common from '@/lib/common'

export default {
  data() {
    return {
      pay_summ: 500,
      balance: '',
      price: 0,
      pay_href: ''
    }
  },
  created() {
    this.getUserBalance()
  },
  methods: {
    showDays(summ){
      let result = 0

      if(this.price !== 0 && summ !== 0){
        result = Math.ceil(summ/this.price)
      } else if(this.price === 0 && (summ === 0 || summ === '')){
        result = 0
      } else if(this.price === 0 && (summ !== 0 || summ !== '')){
        result = '"много"'
      }
      
      return result
    },
    async getUserBalance(){
      const self = this

      axios.get(urls.getUserBalance, await common.setAuthorizationHeader()).then(response => {
        if(typeof response.data !== 'undefined' && typeof response.data.balance !== 'undefined' && typeof response.data.price !== 'undefined'){
          self.balance = Math.ceil(response.data.balance / 100)
          self.price = Math.ceil(response.data.price / 100)
        }
      }).catch(error => {
        let errorParsed = common.errorQueryHandler(error)

        if(errorParsed.type === 'unauthorization'){
          common.queryRefreshToken(error).then(response => {
            if(typeof response.data !== 'undefined' && typeof response.data.balance !== 'undefined' && typeof response.data.price !== 'undefined'){
              self.balance = Math.ceil(response.data.balance / 100)
              self.price = Math.ceil(response.data.price / 100)
            }
          }).catch(err => {
            console.log(err)
          })
        } else if(errorParsed.type === 'some'){
          console.log(errorParsed.error)
        } else{
          console.log(error)
        }
      })
    },
    async payCard(){
      const self = this

      axios.get(urls.getPayRobo(this.pay_summ*100), await common.setAuthorizationHeader()).then(response => {
        this.pay_href = response.data.url
        let arr_fields = response.data.body.split('&')
        arr_fields.map(e => {
          let chains = e.split('=')
          document.getElementsByName(chains[0])[0].value = chains[1]
          return e
        })
        document.getElementById('pay_form').action = this.pay_href
        document.getElementById('pay_form').submit()
      }).catch(error => {
        let errorParsed = common.errorQueryHandler(error)

        if(errorParsed.type === 'unauthorization'){
          common.queryRefreshToken(error).then(response => {
            self.pay_href = response.data.url
            let arr_fields = response.data.body.split('&')
            arr_fields.map(e => {
              let chains = e.split('=')
              document.getElementsByName(chains[0])[0].value = chains[1]
              return e
            })
            document.getElementById('pay_form').action = self.pay_href
            document.getElementById('pay_form').submit()
          }).catch(err => {
            console.log(err)
          })
        } else if(errorParsed.type === 'some'){
          console.log(errorParsed.error)
        } else{
          console.log(error)
        }
      })
    },
    payBill(){
      this.$router.push({ path: '/order', query: { summ: this.pay_summ } })
    }
  },
  watch: {
    pay_summ(){
      if(this.pay_summ <= 0){
        this.pay_summ = 1
      }
    }
  },
}
</script>